<template>
  <Teleport to="body">
  <template v-if="visivel">
  <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable crm-modal-wide">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ usuario ? 'Editar Usuário' : 'Novo Usuário' }}</h5>
          <button type="button" class="btn-close" @click="fechar"></button>
        </div>
        <form @submit.prevent="salvar">
          <div class="modal-body">
            <BRow>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Nome <span class="text-danger">*</span></label>
                  <input v-model="form.nome" type="text" class="form-control" :class="{ 'is-invalid': erros.nome }" />
                  <div v-if="erros.nome" class="invalid-feedback">{{ erros.nome }}</div>
                </div>
              </BCol>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Email <span class="text-danger">*</span></label>
                  <input v-model="form.email" type="email" class="form-control" :class="{ 'is-invalid': erros.email }" />
                  <div v-if="erros.email" class="invalid-feedback">{{ erros.email }}</div>
                </div>
              </BCol>
            </BRow>

            <div class="mb-3">
              <label class="form-label">
                Senha
                <span v-if="!usuario" class="text-danger">*</span>
                <small v-else class="text-muted">(deixe vazio para manter)</small>
              </label>
              <div class="input-group">
                <input
                  v-model="form.senha"
                  :type="mostrarSenha ? 'text' : 'password'"
                  class="form-control"
                  :class="{ 'is-invalid': erros.senha }"
                  :placeholder="usuario ? '••••••••' : ''"
                />
                <button class="btn btn-outline-secondary" type="button" @click="mostrarSenha = !mostrarSenha">
                  <i :class="mostrarSenha ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                </button>
                <div v-if="erros.senha" class="invalid-feedback">{{ erros.senha }}</div>
              </div>
            </div>

            <hr class="my-3" />

            <BRow>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Status</label>
                  <div class="form-check form-switch">
                    <input
                      v-model="form.ativo"
                      class="form-check-input"
                      type="checkbox"
                      :disabled="usuario && usuario.id === currentUserId"
                    />
                    <label class="form-check-label">
                      {{ form.ativo ? 'Ativo' : 'Inativo' }}
                    </label>
                  </div>
                </div>
              </BCol>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Perfil</label>
                  <div class="form-check form-switch">
                    <input
                      v-model="form.super"
                      class="form-check-input"
                      type="checkbox"
                      :true-value="1"
                      :false-value="0"
                      :disabled="usuario && usuario.id === currentUserId"
                    />
                    <label class="form-check-label">
                      {{ form.super === 1 ? 'Administrador' : 'Usuário comum' }}
                    </label>
                  </div>
                  <small class="text-muted">Administradores têm acesso a todos os menus.</small>
                </div>
              </BCol>
            </BRow>

            <div v-if="form.super !== 1" class="mb-3">
              <label class="form-label">Menus permitidos</label>
              <div :class="{ 'is-invalid': erros.menus }">
                <div v-if="!menus.length" class="text-muted">Nenhum menu cadastrado.</div>
                <div v-else class="d-flex flex-wrap gap-2">
                  <div
                    v-for="menu in menus"
                    :key="menu.id"
                    class="form-check"
                  >
                    <input
                      v-model="form.menus"
                      :value="menu.id"
                      class="form-check-input"
                      type="checkbox"
                      :id="'menu-' + menu.id"
                    />
                    <label class="form-check-label" :for="'menu-' + menu.id">
                      <i :class="menu.icon" class="me-1"></i>
                      {{ menu.name }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="erros.menus" class="invalid-feedback d-block">{{ erros.menus }}</div>
            </div>

            <div v-if="erroApi" class="alert alert-danger mt-3 mb-0">
              <i class="ri-error-warning-line me-1"></i> {{ erroApi }}
            </div>
          </div>
          <div class="modal-footer">
            <BButton variant="ghost-dark" @click="fechar">Cancelar</BButton>
            <BButton type="submit" variant="success" :disabled="salvando">
              <BSpinner v-if="salvando" small class="me-1" />
              {{ salvando ? 'Salvando...' : 'Salvar' }}
            </BButton>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" @click="fechar"></div>
  </template>
  </Teleport>
</template>

<script>
import { api, sucesso } from '@/helpers/common/api';

export default {
  name: 'UsuarioModal',
  props: {
    visivel: { type: Boolean, default: false },
    usuario: { type: Object, default: null },
    menus: { type: Array, default: () => [] },
    currentUserId: { type: Number, default: null },
  },
  emits: ['fechar', 'salvo'],
  data() {
    return {
      form: this.formVazio(),
      erros: {},
      erroApi: '',
      salvando: false,
      mostrarSenha: false,
    };
  },
  watch: {
    usuario: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            nome: val.nome || '',
            email: val.email || '',
            senha: '',
            ativo: val.ativo !== false,
            super: val.super || 0,
            menus: Array.isArray(val.menus) ? [...val.menus] : [],
          };
        } else {
          this.form = this.formVazio();
        }
        this.erros = {};
        this.erroApi = '';
        this.mostrarSenha = false;
      },
    },
  },
  methods: {
    formVazio() {
      return {
        nome: '',
        email: '',
        senha: '',
        ativo: true,
        super: 0,
        menus: [],
      };
    },

    validar() {
      this.erros = {};
      if (!this.form.nome.trim()) this.erros.nome = 'Nome é obrigatório.';
      if (!this.form.email.trim()) this.erros.email = 'Email é obrigatório.';
      if (!this.usuario && !this.form.senha) this.erros.senha = 'Senha é obrigatória para novo usuário.';
      if (this.form.senha && this.form.senha.length < 6) this.erros.senha = 'Senha deve ter pelo menos 6 caracteres.';
      if (this.form.super !== 1 && !this.form.menus.length) this.erros.menus = 'Selecione pelo menos um menu.';
      return Object.keys(this.erros).length === 0;
    },

    async salvar() {
      if (!this.validar()) return;
      this.salvando = true;
      this.erroApi = '';

      const payload = {
        nome: this.form.nome.trim(),
        email: this.form.email.trim(),
        ativo: this.form.ativo,
        super: this.form.super,
        menus: this.form.super === 1 ? null : this.form.menus,
      };

      if (this.form.senha) {
        payload.senha = this.form.senha;
      }

      let result;
      try {
        if (this.usuario) {
          result = await api.update(`/usuario/${this.usuario.id}`, payload);
        } else {
          result = await api.create('/usuario', payload);
        }
      } catch (e) {
        // api wrapper retorna false em erro
      }

      this.salvando = false;

      if (result && result.error) {
        this.erroApi = result.error;
        return;
      }

      if (result) {
        sucesso();
        this.$emit('salvo', result);
        this.$emit('fechar');
      }
    },

    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}
.modal-backdrop {
  z-index: 1040;
  cursor: pointer;
}
.crm-modal-wide {
  max-width: min(700px, calc(100vw - 1rem));
}
</style>
